import * as React from 'react'
import {WrappedFieldProps} from 'redux-form'
import Chip from '@luminopia/react-toolbox/lib/chip'
import * as classNames from './multi-email-input.css'

interface IProps extends WrappedFieldProps<{}> {
}

interface IComponentState {
  emails: string[]
  inputValue: string
  error: string | null
}

export default class MultiEmailInput extends React.PureComponent<IProps, IComponentState> {
  constructor(props: IProps) {
    super(props)
    const emails: string = this.props.input ? this.props.input.value : ''
    this.state = {
      emails: emails ? emails.split(',') : [],
      inputValue: '',
      error: null
    }
  }

  componentWillReceiveProps(nextProps: IProps) {
    if (!nextProps.input) { return }
    const emails: string = nextProps.input.value || ''
    this.setState({ emails: emails ? emails.split(',') : [] })
  }

  isInList(email: string) {
    return this.state.emails.indexOf(email) >= 0
  }

  isEmail(email: string) {
    return /[\w\d\.-]+@[\w\d\.-]+\.[\w\d\.-]+/.test(email)
  }

  isValid(email: string) {
    let error = null;

    if (this.isInList(email)) {
      error = `${email} has already been added`
    }

    if (!this.isEmail(email)) {
      error = `${email} is not a valid email address`
    }

    if (error) {
      this.setState({ error });
      return false;
    }

    return true;
  }

  private checkEmail () {
    if (!this.props.input) { return }
    const value = this.state.inputValue.trim()

    if (value && this.isValid(value)) {
      const emails = [...this.state.emails, value]
      this.setState({
        inputValue: ""
      })
      this.props.input.onChange(emails.join(','), undefined, undefined)
    }
  }

  handleKeyDown = (evt: React.KeyboardEvent<HTMLTextAreaElement>) => {
    if (["Enter", "Tab", ","].indexOf(evt.key) >= 0) {
      evt.preventDefault()
      this.checkEmail()
    }
  }

  handleBlur = (evt: React.FocusEvent<HTMLTextAreaElement>) => {
    evt.preventDefault()
    this.checkEmail()
  }

  handleInputChange = (evt: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({
      inputValue: evt.target.value,
      error: null
    })
  }

  handleDelete = (email: string) => {
    if (!this.props.input) { return }
    const emails = this.state.emails.filter((e) => e !== email)
    this.props.input.onChange(emails.join(','), undefined, undefined)
  }

  handlePaste = (evt: React.ClipboardEvent<HTMLTextAreaElement>) => {
    if (!this.props.input) { return }
    evt.preventDefault()

    const paste = evt.clipboardData.getData("text")
    const emailArr = paste.replace(/[<>]/g, '').trim().split(',')
    const toBeAdded = emailArr.filter((email) => Boolean(email) && !this.isInList(email)).map(e => e.trim())
    const emails = [...this.state.emails, ...toBeAdded]

    this.props.input.onChange(emails.join(','), undefined, undefined)
  }

  public render() {
    return (
      <div className={classNames.container}>
        <label htmlFor="email-list-entry">
          Invite technicians
        </label>
        <div className={classNames.textareaContainer}>
          {this.state.emails.map((email) => (
            <Chip
              key={email}
              deletable
              onDeleteClick={() => this.handleDelete(email)}
              className={this.isEmail(email) ? classNames.chip : classNames.chipError}
            >
              {email}
            </Chip>
          ))}
          <textarea
            id="email-list-entry"
            name="emails"
            value={this.state.inputValue}
            onChange={this.handleInputChange}
            onKeyDown={this.handleKeyDown}
            onBlur={this.handleBlur}
            placeholder={this.state.emails.length === 0 ? "Enter email addresses" : undefined}
            onPaste={this.handlePaste}
          />
        </div>
        {this.state.error && <p className={classNames.error}>{this.state.error}</p>}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/form/multi-email-input.tsx